module.exports = __webpack_public_path__ + "media/images/icons-6f6518d42dfcedb460af03dd05942154.svg";